let dbInstance = null;

const initDB = () => {
  return new Promise((resolve, reject) => {
    if (dbInstance) {
      resolve(dbInstance);
      return;
    }

    const request = indexedDB.open("DownloadDB", 1);

    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains("chunks")) {
        db.createObjectStore("chunks", { keyPath: "id" });
      }
    };

    request.onsuccess = () => {
      dbInstance = request.result;
      resolve(dbInstance);
    };

    request.onerror = () => reject(request.error);
  });
};

export const saveChunk = async (streamId, chunk, offset) => {
  const db = await initDB();
  const transaction = db.transaction("chunks", "readwrite");
  const store = transaction.objectStore("chunks");

  return new Promise((resolve, reject) => {
    // Pad the offset with zeros to ensure correct string sorting
    const paddedOffset = offset.toString().padStart(20, "0");
    const request = store.put({
      id: `${streamId}_${paddedOffset}`,
      chunk: new Uint8Array(chunk),
      offset,
    });

    request.onsuccess = () => resolve();
    request.onerror = () => reject(request.error);
  });
};

export const loadChunks = async (streamId) => {
  const db = await initDB();
  const transaction = db.transaction("chunks", "readonly");
  const store = transaction.objectStore("chunks");

  return new Promise((resolve, reject) => {
    const request = store.getAll();

    request.onsuccess = () => {
      const allChunks = request.result
        .filter((chunk) => chunk.id.startsWith(`${streamId}_`))
        // Sort by actual offset number, not string comparison
        .sort((a, b) => a.offset - b.offset)
        .map((chunk) => chunk.chunk);

      resolve(allChunks);
    };

    request.onerror = () => reject(request.error);
  });
};

export const clearChunks = async (streamId) => {
  const db = await initDB();
  const transaction = db.transaction("chunks", "readwrite");
  const store = transaction.objectStore("chunks");

  return new Promise((resolve, reject) => {
    const request = store.getAllKeys();

    request.onsuccess = () => {
      const allKeys = request.result;
      const keysToDelete = allKeys.filter((key) => key.startsWith(`${streamId}_`));

      const deletePromises = keysToDelete.map((key) => {
        return new Promise((resolveDelete, rejectDelete) => {
          const deleteRequest = store.delete(key);
          deleteRequest.onsuccess = () => resolveDelete();
          deleteRequest.onerror = () => rejectDelete(deleteRequest.error);
        });
      });

      Promise.all(deletePromises)
        .then(() => resolve())
        .catch((error) => reject(error));
    };

    request.onerror = () => reject(request.error);
  });
};
